import { cls_event_state_approved, cls_event_state_cancelled, cls_event_state_checked, cls_event_state_private, cls_event_state_public, cls_event_state_waiting } from "public_app/events/entity.css";
import { AgeType, CompetitionClassType, CompetitionType, CompetitorType, DisciplineType, EventState, SeriesType, CompetitionClassTypeItems } from "../events/entity";
export function getCompetitorTypeRegular(val, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (val == CompetitorType.Couple) {
        return 'Pár';
    }
    if (val == CompetitorType.SoloDancer) {
        return 'Jednotlivci';
    }
    if (val == CompetitorType.Duo) {
        return 'Duo';
    }
    if (val == CompetitorType.Group) {
        return 'Skupina';
    }
    if (val == CompetitorType.ProAm) {
        return 'ProAm';
    }
    if (val == CompetitorType.Team) {
        return 'Družstvo';
    }
    if (val == CompetitorType.Formation) {
        return 'Formace';
    }
    if (val == CompetitorType.SmallTeam) {
        return 'Malý tým';
    }
    if (val == CompetitorType.BigTeam) {
        return 'Velký tým';
    }
    return defaultValue;
}
export function getCompetitorTypeRegularForSelect(val) {
    return getCompetitorTypeRegular(val, '- všechny -');
}
export function getCompetitorTypeAbbreviation(val, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (val == CompetitorType.Couple) {
        return 'Pár';
    }
    if (val == CompetitorType.SoloDancer) {
        return 'Sólo';
    }
    if (val == CompetitorType.Duo) {
        return 'Duo';
    }
    if (val == CompetitorType.Group) {
        return 'Skup.';
    }
    if (val == CompetitorType.ProAm) {
        return 'ProAm';
    }
    if (val == CompetitorType.Team) {
        return 'Druž.';
    }
    if (val == CompetitorType.Formation) {
        return 'Form.';
    }
    if (val == CompetitorType.SmallTeam) {
        return 'MT';
    }
    if (val == CompetitorType.BigTeam) {
        return 'VT';
    }
    return defaultValue;
}
export function getCompetitorTypeAbbreviationForSelect(val) {
    return getCompetitorTypeAbbreviation(val, 'vše');
}
export function getCompetitorTypeFromString(val) {
    if (val === 'Couple') {
        return CompetitorType.Couple;
    }
    if (val === 'SoloDancer') {
        return CompetitorType.SoloDancer;
    }
    if (val === 'Duo') {
        return CompetitorType.Duo;
    }
    if (val === 'Group') {
        return CompetitorType.Group;
    }
    if (val === 'ProAm') {
        return CompetitorType.ProAm;
    }
    if (val === 'Team') {
        return CompetitorType.Team;
    }
    if (val === 'Formation') {
        return CompetitorType.Formation;
    }
    if (val === 'SmallTeam') {
        return CompetitorType.SmallTeam;
    }
    if (val === 'BigTeam') {
        return CompetitorType.BigTeam;
    }
    return null;
}
export function getSeriesTypeRegular(val, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (val == SeriesType.DanceForAll) {
        return 'Tanec pro všechny';
    }
    if (val == SeriesType.Professional) {
        return 'Profesionálové';
    }
    if (val == SeriesType.DanceSport) {
        return 'Výkonnostní sport';
    }
    if (val == SeriesType.Caribbean) {
        return 'Karibské tance';
    }
    return defaultValue;
}
export function getSeriesTypeRegularForSelect(val) {
    return getSeriesTypeRegular(val, '- všechny -');
}
export function getSeriesTypeAbbreviation(val, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (val == SeriesType.DanceForAll) {
        return 'TPV';
    }
    if (val == SeriesType.Professional) {
        return 'Profi';
    }
    if (val == SeriesType.DanceSport) {
        return 'VS';
    }
    if (val == SeriesType.Caribbean) {
        return 'KRB';
    }
    return defaultValue;
}
export function getSeriesTypeAbbreviationForSelect(val) {
    return getSeriesTypeAbbreviation(val, 'vše');
}
export function getSeriesTypeFromString(val) {
    if (val == 'DanceForAll') {
        return SeriesType.DanceForAll;
    }
    if (val == 'Professional') {
        return SeriesType.Professional;
    }
    if (val == 'DanceSport') {
        return SeriesType.DanceSport;
    }
    if (val == 'Caribbean') {
        return SeriesType.Caribbean;
    }
    return SeriesType.Unknown;
}
export function getCompetitionTypeRegular(val, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (val == CompetitionType.Cup) {
        return 'Pohárová';
    }
    if (val == CompetitionType.Ranking) {
        return 'Postupová';
    }
    if (val == CompetitionType.League) {
        return 'Taneční liga';
    }
    if (val == CompetitionType.Championship) {
        return 'Mistrovství České republiky';
    }
    if (val == CompetitionType.TopLevel) {
        return 'Vrcholová';
    }
    if (val == CompetitionType.SuperLeague) {
        return 'Super taneční liga';
    }
    if (val == CompetitionType.G_Cup) {
        return 'G-Cup';
    }
    return defaultValue;
}
export function getCompetitionTypeRegularForSelect(val) {
    return getCompetitionTypeRegular(val, '- všechny -');
}
export function getCompetitionTypeAbbreviation(val, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (val == CompetitionType.Cup) {
        return 'Cup';
    }
    if (val == CompetitionType.Ranking) {
        return 'Post.';
    }
    if (val == CompetitionType.League) {
        return 'TL';
    }
    if (val == CompetitionType.Championship) {
        return 'MČR';
    }
    if (val == CompetitionType.TopLevel) {
        return 'VS';
    }
    if (val == CompetitionType.SuperLeague) {
        return 'STL';
    }
    if (val == CompetitionType.G_Cup) {
        return 'G-Cup';
    }
    return defaultValue;
}
export function getCompetitionTypeAbbreviationForSelect(val) {
    return getCompetitionTypeAbbreviation(val, 'vše');
}
export function getCompetitionTypeFromString(val) {
    if (val == 'Cup') {
        return CompetitionType.Cup;
    }
    if (val == 'Ranking') {
        return CompetitionType.Ranking;
    }
    if (val == 'League') {
        return CompetitionType.League;
    }
    if (val == 'Championship') {
        return CompetitionType.Championship;
    }
    if (val == 'TopLevel') {
        return CompetitionType.TopLevel;
    }
    if (val == 'SuperLeague') {
        return CompetitionType.SuperLeague;
    }
    if (val == 'G-Cup') {
        return CompetitionType.G_Cup;
    }
    return CompetitionType.Unknown;
}
export function getAgeTypeRegular(val, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (val == AgeType.Under_8) {
        return 'Do-8-let';
    }
    if (val == AgeType.Juvenile_I) {
        return 'Děti-1';
    }
    if (val == AgeType.Juvenile_II) {
        return 'Děti-2';
    }
    if (val == AgeType.Juvenile) {
        return 'Děti';
    }
    if (val == AgeType.Junior_I) {
        return 'Junioři-1';
    }
    if (val == AgeType.Junior_II) {
        return 'Junioři-2';
    }
    if (val == AgeType.Junior) {
        return 'Junioři';
    }
    if (val == AgeType.Youth) {
        return 'Mládež';
    }
    if (val == AgeType.Under_21) {
        return 'Do-21-let';
    }
    if (val == AgeType.Adult) {
        return 'Dospělí';
    }
    if (val == AgeType.Senior_I) {
        return 'Senioři-1';
    }
    if (val == AgeType.Senior_Ia) {
        return 'Senioři-1a';
    }
    if (val == AgeType.Senior_Ib) {
        return 'Senioři-1b';
    }
    if (val == AgeType.Senior_II) {
        return 'Senioři-2';
    }
    if (val == AgeType.Senior_III) {
        return 'Senioři-3';
    }
    if (val == AgeType.Senior_IV) {
        return 'Senioři-4';
    }
    if (val == AgeType.Senior_V) {
        return 'Senioři-5';
    }
    if (val == AgeType.Senior) {
        return 'Senioři';
    }
    return defaultValue;
}
export function getAgeTypeRegularForSelect(val) {
    return getAgeTypeRegular(val, '- všechny -');
}
export function getAgeTypeAbbreviation(val, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (val == AgeType.Under_8) {
        return 'U8';
    }
    if (val == AgeType.Juvenile_I) {
        return 'D1';
    }
    if (val == AgeType.Juvenile_II) {
        return 'D2';
    }
    if (val == AgeType.Juvenile) {
        return 'D1+2';
    }
    if (val == AgeType.Junior_I) {
        return 'J1';
    }
    if (val == AgeType.Junior_II) {
        return 'J2';
    }
    if (val == AgeType.Junior) {
        return 'J1+2';
    }
    if (val == AgeType.Youth) {
        return 'Ml';
    }
    if (val == AgeType.Under_21) {
        return 'U21';
    }
    if (val == AgeType.Adult) {
        return 'D';
    }
    if (val == AgeType.Senior_I) {
        return 'S1';
    }
    if (val == AgeType.Senior_Ia) {
        return 'S1a';
    }
    if (val == AgeType.Senior_Ib) {
        return 'S1b';
    }
    if (val == AgeType.Senior_II) {
        return 'S2';
    }
    if (val == AgeType.Senior_III) {
        return 'S3';
    }
    if (val == AgeType.Senior_IV) {
        return 'S4';
    }
    if (val == AgeType.Senior_V) {
        return 'S5';
    }
    if (val == AgeType.Senior) {
        return 'S';
    }
    return defaultValue;
}
export function getAgeTypeAbbreviationForSelect(val) {
    return getAgeTypeAbbreviation(val, 'vše');
}
export function getAgeTypeFromString(val) {
    if (val == 'Under 8') {
        return AgeType.Under_8;
    }
    if (val == 'Juvenile I') {
        return AgeType.Juvenile_I;
    }
    if (val == 'Juvenile II') {
        return AgeType.Juvenile_II;
    }
    if (val == 'Juvenile') {
        return AgeType.Juvenile;
    }
    if (val == 'Junior I') {
        return AgeType.Junior_I;
    }
    if (val == 'Junior II') {
        return AgeType.Junior_II;
    }
    if (val == 'Junior') {
        return AgeType.Junior;
    }
    if (val == 'Youth') {
        return AgeType.Youth;
    }
    if (val == 'Under 21') {
        return AgeType.Under_21;
    }
    if (val == 'Adult') {
        return AgeType.Adult;
    }
    if (val == 'Senior I') {
        return AgeType.Senior_I;
    }
    if (val == 'Senior Ia') {
        return AgeType.Senior_Ia;
    }
    if (val == 'Senior Ib') {
        return AgeType.Senior_Ib;
    }
    if (val == 'Senior II') {
        return AgeType.Senior_II;
    }
    if (val == 'Senior III') {
        return AgeType.Senior_III;
    }
    if (val == 'Senior IV') {
        return AgeType.Senior_IV;
    }
    if (val == 'Senior V') {
        return AgeType.Senior_V;
    }
    if (val == 'Senior') {
        return AgeType.Senior;
    }
    return AgeType.Unknown;
}
export function getAllowedAgeIdsForTeamOrFormationMembers(val) {
    if (val == AgeType.Unknown) {
        return [];
    }
    if (val == AgeType.Under_8) {
        return [AgeType.Under_8];
    }
    if (val == AgeType.Juvenile_I) {
        return [AgeType.Under_8, AgeType.Juvenile_I];
    }
    if (val == AgeType.Juvenile_II) {
        return [AgeType.Under_8, AgeType.Juvenile_I, AgeType.Juvenile_II];
    }
    if (val == AgeType.Juvenile) {
        return [AgeType.Under_8, AgeType.Juvenile, AgeType.Juvenile_I, AgeType.Juvenile_II];
    }
    if (val == AgeType.Junior_I) {
        return [AgeType.Juvenile_II, AgeType.Junior_I];
    }
    if (val == AgeType.Junior_II) {
        return [AgeType.Junior_I, AgeType.Junior_II];
    }
    if (val == AgeType.Junior) {
        return [AgeType.Juvenile_II, AgeType.Junior, AgeType.Junior_I, AgeType.Junior_II];
    }
    if (val == AgeType.Youth) {
        return [AgeType.Junior_II, AgeType.Youth];
    }
    if (val == AgeType.Under_21) {
        return [AgeType.Youth, AgeType.Under_21];
    }
    if (val == AgeType.Adult) {
        return [AgeType.Youth, AgeType.Under_21, AgeType.Adult, AgeType.Senior, AgeType.Senior_I, AgeType.Senior_Ia, AgeType.Senior_Ib, AgeType.Senior_II, AgeType.Senior_III, AgeType.Senior_IV, AgeType.Senior_V];
    }
    if (val == AgeType.Senior) {
        return [AgeType.Senior, AgeType.Senior_I, AgeType.Senior_Ia, AgeType.Senior_Ib, AgeType.Senior_II, AgeType.Senior_III, AgeType.Senior_IV, AgeType.Senior_V];
    }
    if (val == AgeType.Senior_I) {
        return [AgeType.Senior, AgeType.Senior_I, AgeType.Senior_Ia, AgeType.Senior_Ib, AgeType.Senior_II, AgeType.Senior_III, AgeType.Senior_IV, AgeType.Senior_V];
    }
    if (val == AgeType.Senior_II) {
        return [AgeType.Senior_II, AgeType.Senior_III, AgeType.Senior_IV, AgeType.Senior_V];
    }
    if (val == AgeType.Senior_III) {
        return [AgeType.Senior_III, AgeType.Senior_IV, AgeType.Senior_V];
    }
    if (val == AgeType.Senior_IV) {
        return [AgeType.Senior_IV, AgeType.Senior_V];
    }
    if (val == AgeType.Senior_V) {
        return [AgeType.Senior_V];
    }
    return [];
}
export function getAllowedAgeIdsForGroupMembers(val, championshipException, smallAndBigTeamChampionshipException) {
    if (smallAndBigTeamChampionshipException) {
        if (val == AgeType.Under_8) {
            return [AgeType.Under_8, AgeType.Juvenile_I];
        }
        if (val == AgeType.Juvenile_I) {
            return [AgeType.Under_8, AgeType.Juvenile_I, AgeType.Juvenile_II];
        }
        if (val == AgeType.Juvenile_II) {
            return [AgeType.Under_8, AgeType.Juvenile_I, AgeType.Juvenile_II, AgeType.Junior_I];
        }
        if (val == AgeType.Juvenile) {
            return [AgeType.Under_8, AgeType.Juvenile, AgeType.Juvenile_I, AgeType.Juvenile_II, AgeType.Junior_I];
        }
        if (val == AgeType.Junior_I) {
            return [AgeType.Juvenile_I, AgeType.Juvenile_II, AgeType.Junior_I, AgeType.Junior_II];
        }
        if (val == AgeType.Junior_II) {
            return [AgeType.Juvenile_I, AgeType.Juvenile_II, AgeType.Junior_I, AgeType.Junior_II, AgeType.Youth];
        }
        if (val == AgeType.Junior) {
            return [AgeType.Juvenile_I, AgeType.Juvenile_II, AgeType.Junior, AgeType.Junior_I, AgeType.Junior_II, AgeType.Youth];
        }
        if (val == AgeType.Youth) {
            return [AgeType.Juvenile_I, AgeType.Juvenile_II, AgeType.Junior_I, AgeType.Junior_II, AgeType.Youth, AgeType.Under_21];
        }
        if (val == AgeType.Under_21) {
            return [AgeType.Juvenile_I, AgeType.Juvenile_II, AgeType.Junior_I, AgeType.Junior_II, AgeType.Youth, AgeType.Under_21, AgeType.Adult];
        }
        if (val == AgeType.Adult) {
            return [AgeType.Juvenile_I, AgeType.Juvenile_II, AgeType.Junior_I, AgeType.Junior_II, AgeType.Youth, AgeType.Under_21, AgeType.Adult];
        }
    }
    if (val == AgeType.Unknown) {
        return [];
    }
    if (val == AgeType.Under_8) {
        return [AgeType.Under_8, AgeType.Juvenile_I];
    }
    if (val == AgeType.Juvenile_I) {
        return [AgeType.Under_8, AgeType.Juvenile_I, AgeType.Juvenile_II];
    }
    if (val == AgeType.Juvenile_II) {
        return [AgeType.Under_8, AgeType.Juvenile_I, AgeType.Juvenile_II, AgeType.Junior_I];
    }
    if (val == AgeType.Juvenile) {
        return [AgeType.Under_8, AgeType.Juvenile, AgeType.Juvenile_I, AgeType.Juvenile_II, AgeType.Junior_I];
    }
    if (val == AgeType.Junior_I) {
        return [AgeType.Juvenile_II, AgeType.Junior_I, AgeType.Junior_II];
    }
    if (val == AgeType.Junior_II) {
        if (championshipException) {
            return [AgeType.Juvenile_I, AgeType.Juvenile_II, AgeType.Junior_I, AgeType.Junior_II, AgeType.Youth];
        }
        else {
            return [AgeType.Junior_I, AgeType.Junior_II, AgeType.Youth];
        }
    }
    if (val == AgeType.Junior) {
        return [AgeType.Juvenile_II, AgeType.Junior, AgeType.Junior_I, AgeType.Junior_II, AgeType.Youth];
    }
    if (val == AgeType.Youth) {
        return [AgeType.Junior_II, AgeType.Youth, AgeType.Under_21];
    }
    if (val == AgeType.Under_21) {
        return [AgeType.Youth, AgeType.Under_21, AgeType.Adult];
    }
    if (val == AgeType.Adult) {
        return [AgeType.Youth, AgeType.Under_21, AgeType.Adult];
    }
    return [];
}
export function getAllowedOlderAgeIdsForGroupMembers(val) {
    if (val == AgeType.Unknown) {
        return [];
    }
    if (val == AgeType.Under_8) {
        return [AgeType.Juvenile_I];
    }
    if (val == AgeType.Juvenile_I) {
        return [AgeType.Juvenile_II];
    }
    if (val == AgeType.Juvenile_II) {
        return [AgeType.Junior_I];
    }
    if (val == AgeType.Juvenile) {
        return [AgeType.Junior_I];
    }
    if (val == AgeType.Junior_I) {
        return [AgeType.Junior_II];
    }
    if (val == AgeType.Junior_II) {
        return [AgeType.Youth];
    }
    if (val == AgeType.Junior) {
        return [AgeType.Youth];
    }
    if (val == AgeType.Youth) {
        return [AgeType.Under_21];
    }
    if (val == AgeType.Under_21) {
        return [AgeType.Adult];
    }
    if (val == AgeType.Adult) {
        return [];
    }
    return [];
}
export function getAllowedNumberOfOlderPeopleInGroup(totalNumberOfGroupMembers) {
    if (totalNumberOfGroupMembers < 3) {
        return 0;
    }
    if (totalNumberOfGroupMembers <= 7) {
        return 1;
    }
    if (totalNumberOfGroupMembers <= 14) {
        return 2;
    }
    if (totalNumberOfGroupMembers <= 20) {
        return 3;
    }
    if (totalNumberOfGroupMembers <= 24) {
        return 4;
    }
    if (totalNumberOfGroupMembers <= 30) {
        return 5;
    }
    return 0;
}
export function getCompetitionClassTypeRegular(val, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (val == CompetitionClassType.Entry) {
        return 'Entry';
    }
    if (val == CompetitionClassType.E) {
        return 'E';
    }
    if (val == CompetitionClassType.D) {
        return 'D';
    }
    if (val == CompetitionClassType.C) {
        return 'C';
    }
    if (val == CompetitionClassType.B) {
        return 'B';
    }
    if (val == CompetitionClassType.A) {
        return 'A';
    }
    if (val == CompetitionClassType.M) {
        return 'M';
    }
    if (val == CompetitionClassType.Open) {
        return 'Open';
    }
    if (val == CompetitionClassType.Novice) {
        return 'Novice';
    }
    if (val == CompetitionClassType.Bronze) {
        return 'Bronze';
    }
    if (val == CompetitionClassType.Silver) {
        return 'Silver';
    }
    if (val == CompetitionClassType.Gold) {
        return 'Gold';
    }
    return defaultValue;
}
export function getCompetitionClassTypeRegularForSelect(val) {
    return getCompetitionClassTypeRegular(val, '- všechny -');
}
export function getCompetitionClassTypeAbbreviation(val, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (val == CompetitionClassType.Entry) {
        return '–';
    }
    if (val == CompetitionClassType.E) {
        return 'E';
    }
    if (val == CompetitionClassType.D) {
        return 'D';
    }
    if (val == CompetitionClassType.C) {
        return 'C';
    }
    if (val == CompetitionClassType.B) {
        return 'B';
    }
    if (val == CompetitionClassType.A) {
        return 'A';
    }
    if (val == CompetitionClassType.M) {
        return 'M';
    }
    if (val == CompetitionClassType.Open) {
        return 'O';
    }
    if (val == CompetitionClassType.Novice) {
        return 'N';
    }
    if (val == CompetitionClassType.Bronze) {
        return 'B';
    }
    if (val == CompetitionClassType.Silver) {
        return 'S';
    }
    if (val == CompetitionClassType.Gold) {
        return 'G';
    }
    return defaultValue;
}
export function getCompetitionClassTypeAbbreviationForSelect(val) {
    return getCompetitionClassTypeAbbreviation(val, 'vše');
}
export function getCompetitionClassTypeFromString(val) {
    if (val === 'Entry') {
        return CompetitionClassType.Entry;
    }
    if (val === 'E') {
        return CompetitionClassType.E;
    }
    if (val === 'D') {
        return CompetitionClassType.D;
    }
    if (val === 'C') {
        return CompetitionClassType.C;
    }
    if (val === 'B') {
        return CompetitionClassType.B;
    }
    if (val === 'A') {
        return CompetitionClassType.A;
    }
    if (val === 'M') {
        return CompetitionClassType.M;
    }
    if (val === 'S') {
        return CompetitionClassType.M;
    }
    if (val === 'Open') {
        return CompetitionClassType.Open;
    }
    if (val === 'Novice') {
        return CompetitionClassType.Novice;
    }
    if (val === 'Bronze') {
        return CompetitionClassType.Bronze;
    }
    if (val === 'Silver') {
        return CompetitionClassType.Silver;
    }
    if (val === 'Gold') {
        return CompetitionClassType.Gold;
    }
    return CompetitionClassType.Unknown;
}
export function getDisciplineTypeRegular(val, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (val == DisciplineType.Standard) {
        return 'STT';
    }
    if (val == DisciplineType.Latin) {
        return 'LAT';
    }
    if (val == DisciplineType.Standard_Latin) {
        return 'STT+LAT';
    }
    if (val == DisciplineType.Breaking) {
        return 'Breaking';
    }
    if (val == DisciplineType.SingleDance) {
        return 'Jeden tanec';
    }
    if (val == DisciplineType.FreeStyle) {
        return 'FreeStyle';
    }
    if (val == DisciplineType.Other) {
        return 'Ostatní';
    }
    if (val == DisciplineType.ShowdanceStandard) {
        return 'Showdance STT';
    }
    if (val == DisciplineType.ShowdanceLatin) {
        return 'Showdance LAT';
    }
    if (val == DisciplineType.TenDance) {
        return '10 tanců';
    }
    if (val == DisciplineType.Bachata) {
        return 'Bachata';
    }
    if (val == DisciplineType.Merengue) {
        return 'Merengue';
    }
    if (val == DisciplineType.Salsa) {
        return 'Salsa';
    }
    if (val == DisciplineType.ShowdanceBachata) {
        return 'Showdance Bachata';
    }
    if (val == DisciplineType.ShowdanceMerengue) {
        return 'Showdance Merengue';
    }
    if (val == DisciplineType.ShowdanceSalsa) {
        return 'Showdance Salsa';
    }
    if (val == DisciplineType.Caribbean) {
        return 'Karibik';
    }
    return defaultValue;
}
export function getDisciplineTypeRegularForSelect(val) {
    return getDisciplineTypeRegular(val, '- všechny -');
}
export function getDisciplineTypeAbbreviation(val, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (val == DisciplineType.Standard) {
        return 'STT';
    }
    if (val == DisciplineType.Latin) {
        return 'LAT';
    }
    if (val == DisciplineType.Standard_Latin) {
        return 'S+L';
    }
    if (val == DisciplineType.Breaking) {
        return 'Break';
    }
    if (val == DisciplineType.SingleDance) {
        return '1T';
    }
    if (val == DisciplineType.FreeStyle) {
        return 'Free';
    }
    if (val == DisciplineType.Other) {
        return 'Ostatní';
    }
    if (val == DisciplineType.ShowdanceStandard) {
        return 'ShowSTT';
    }
    if (val == DisciplineType.ShowdanceLatin) {
        return 'ShowLAT';
    }
    if (val == DisciplineType.TenDance) {
        return '10T';
    }
    if (val == DisciplineType.Bachata) {
        return 'Ba';
    }
    if (val == DisciplineType.Merengue) {
        return 'Me';
    }
    if (val == DisciplineType.Salsa) {
        return 'Ss';
    }
    if (val == DisciplineType.ShowdanceBachata) {
        return 'ShowBa';
    }
    if (val == DisciplineType.ShowdanceMerengue) {
        return 'ShowMe';
    }
    if (val == DisciplineType.ShowdanceSalsa) {
        return 'ShowSs';
    }
    if (val == DisciplineType.Caribbean) {
        return 'KRB';
    }
    return defaultValue;
}
export function getDisciplineTypeAbbreviationForSelect(val) {
    return getDisciplineTypeAbbreviation(val, 'vše');
}
export function getDisciplineTypeFromString(val) {
    if (val === 'Standard') {
        return DisciplineType.Standard;
    }
    if (val === 'Latin') {
        return DisciplineType.Latin;
    }
    if (val === 'Standard+Latin') {
        return DisciplineType.Standard_Latin;
    }
    if (val === 'Breaking') {
        return DisciplineType.Breaking;
    }
    if (val === 'SingleDance') {
        return DisciplineType.SingleDance;
    }
    if (val === 'FreeStyle') {
        return DisciplineType.FreeStyle;
    }
    if (val === 'Other') {
        return DisciplineType.Other;
    }
    if (val === 'ShowdanceStandard') {
        return DisciplineType.ShowdanceStandard;
    }
    if (val === 'ShowdanceLatin') {
        return DisciplineType.ShowdanceLatin;
    }
    if (val === 'TenDances') {
        return DisciplineType.TenDance;
    }
    if (val === 'Bachata') {
        return DisciplineType.Bachata;
    }
    if (val === 'Merengue') {
        return DisciplineType.Merengue;
    }
    if (val === 'Salsa') {
        return DisciplineType.Salsa;
    }
    if (val === 'ShowdanceBachata') {
        return DisciplineType.ShowdanceBachata;
    }
    if (val === 'ShowdanceMerengue') {
        return DisciplineType.ShowdanceMerengue;
    }
    if (val === 'ShowdanceSalsa') {
        return DisciplineType.ShowdanceSalsa;
    }
    if (val === 'Caribbean') {
        return DisciplineType.Caribbean;
    }
    return DisciplineType.Unknown;
}
export function getDisciplineTypeAbbreviationWithOptionalDanceName(val, c) {
    // Cup always has selectable set of dances, thus we always provide their shortcuts instead of STT or LAT.
    var res = getDisciplineTypeAbbreviation(val);
    if (c.typeId === CompetitionType.Cup && c.dances.length) {
        res = c.dances.map(function (d) { return getDanceNameShortcut(d); }).join(',');
    }
    else {
        if (c.disciplineId === DisciplineType.SingleDance && c.dances.length) {
            res = getDanceNameShortcut(c.dances[0]);
        }
    }
    return res;
}
export function getEventStateNaming(val) {
    if (val == EventState.Private) {
        return 'V přípravě';
    }
    if (val == EventState.Waiting) {
        return 'Čeká na schválení';
    }
    if (val == EventState.Approved) {
        return 'Čeká na platbu';
    }
    if (val == EventState.Public) {
        return 'V kalendáři';
    }
    if (val == EventState.Cancelled) {
        return 'Zrušená';
    }
    if (val == EventState.Checked) {
        return 'Připraveno ke schválení';
    }
    return '-';
}
export function getEventStateStyleClassName(val) {
    if (val == EventState.Private) {
        return cls_event_state_private;
    }
    if (val == EventState.Waiting) {
        return cls_event_state_waiting;
    }
    if (val == EventState.Approved) {
        return cls_event_state_approved;
    }
    if (val == EventState.Public) {
        return cls_event_state_public;
    }
    if (val == EventState.Cancelled) {
        return cls_event_state_cancelled;
    }
    if (val == EventState.Checked) {
        return cls_event_state_checked;
    }
    return '';
}
function getClassesStringForCup(c1, c2) {
    var val = '';
    CompetitionClassTypeItems.forEach(function (c) {
        if (c.valueOf() >= c1.valueOf() && c.valueOf() <= c2.valueOf()) {
            val += getCompetitionClassTypeAbbreviation(c);
        }
    });
    return val;
}
export function getClassesStringForCompetition(c) {
    if (c.typeId == CompetitionType.Cup && c.fromClassId != c.toClassId && getCompetitionClassTypeAbbreviation(c.toClassId) != '') {
        return getClassesStringForCup(c.fromClassId, c.toClassId);
    }
    else {
        return getCompetitionClassTypeAbbreviation(c.fromClassId); // getCompetitionClassTypeRegular x getCompetitionClassTypeAbbreviation ?
    }
}
export function getDanceNameShortcut(name, max_length) {
    if (max_length === void 0) { max_length = null; }
    if (name === "Waltz") {
        return "W";
    }
    if (name === "Tango") {
        return "T";
    }
    if (name === "Viennese Waltz") {
        return "V";
    }
    if (name === "Slowfox") {
        return "Sf";
    }
    if (name === "Quickstep") {
        return "Q";
    }
    if (name === "Samba") {
        return "Sa";
    }
    if (name === "Chachacha") {
        return "C";
    }
    if (name === "Rumba") {
        return "R";
    }
    if (name === "Paso Doble") {
        return "Pd";
    }
    if (name === "Jive") {
        return "J";
    }
    if (name === "Polka") {
        return "Po";
    }
    if (name === "Bachata") {
        return "Ba";
    }
    if (name === "Merengue") {
        return "Me";
    }
    if (name === "Salsa") {
        return "Ss";
    }
    if (max_length !== null) {
        return name.substring(0, max_length);
    }
    return name;
}
export function getCompetitionNaming(c) {
    var linking = ' ';
    var res = '';
    // here with short version
    if (c.typeId && c.typeId !== CompetitionType.Ranking && c.typeId !== CompetitionType.Cup) {
        if (res != '') {
            res += linking;
        }
        res += getCompetitionTypeAbbreviation(c.typeId);
    }
    if (c.seriesId !== SeriesType.DanceSport) {
        if (res != '') {
            res += linking;
        }
        res += getSeriesTypeAbbreviation(c.seriesId);
    }
    if (res != '') {
        res += linking;
    }
    res += getAgeTypeRegular(c.ageId);
    var validClassesTPV = [
        CompetitionClassType.Novice,
        CompetitionClassType.Bronze,
        CompetitionClassType.Silver,
        CompetitionClassType.Gold,
    ];
    var validClassesDancesport = [
        CompetitionClassType.E,
        CompetitionClassType.D,
        CompetitionClassType.C,
        CompetitionClassType.B,
        CompetitionClassType.A,
        CompetitionClassType.M,
    ];
    if (c.fromClassId !== CompetitionClassType.Unknown) {
        if (c.typeId !== CompetitionType.Championship && c.typeId !== CompetitionType.League && c.typeId !== CompetitionType.SuperLeague) {
            var bothClassesValidAndFromTheSameGroup = (validClassesTPV.includes(c.fromClassId) && validClassesTPV.includes(c.toClassId)) || (validClassesDancesport.includes(c.fromClassId) && validClassesDancesport.includes(c.toClassId));
            res += linking;
            if (c.typeId === CompetitionType.Cup
                && bothClassesValidAndFromTheSameGroup
                && c.fromClassId.valueOf() < c.toClassId.valueOf()) {
                res += getClassesStringForCup(c.fromClassId, c.toClassId);
            }
            else {
                res += getCompetitionClassTypeRegular(c.fromClassId);
            }
        }
    }
    if (c.competitorId !== CompetitorType.Couple) {
        if (c.competitorId !== CompetitorType.SoloDancer || c.disciplineId !== DisciplineType.SingleDance) {
            res += linking;
            res += getCompetitorTypeAbbreviation(c.competitorId);
        }
    }
    if (c.disciplineId !== DisciplineType.Unknown) {
        res += linking;
        res += getDisciplineTypeAbbreviationWithOptionalDanceName(c.disciplineId, c);
    }
    // ending with long version
    if (c.typeId && c.typeId === CompetitionType.Cup) {
        res += linking;
        res += getCompetitionTypeAbbreviation(c.typeId);
    }
    return res;
}
